import ProfileItemForm from "./ProfileItemForm";
import ProfileSchoolRow from "../../profiles/components/ProfileSchoolRow";
import React from "react";
import { FormInputComponent } from "../../../components/form/Form";
import { TalentAppCard } from "./TalentAppCard";
import { Input } from "antd";
import dateformat from "dateformat";

export default class SchoolForm extends ProfileItemForm {

    static ItemType = 'School'

    static FormClass = 'talent-role-form add-talent-form add-school-form '

    static shouldUseTalentAppCard = true;
    static ShowProfilePreview = true;

    static TypeConfig = {
        icon: 'fa fa-graduation-cap',
        color: TB.config('color.blue')
    }

    getModelFromProps() {
        let model = {
            ...(this.props.model || {})
        };

        if (model.started_at) {
            if (typeof model.started_at === 'string') {
                model.started_at = new Date(model.started_at)
            }
            model.started_at_year = model.started_at.getFullYear();
            model.started_at_month = model.started_at.getMonth() + 1;
        }
        if (model.ended_at) {
            if (typeof model.ended_at === 'string') {
                model.ended_at = new Date(model.ended_at)
            }
            model.ended_at_year = model.ended_at.getFullYear();
            model.ended_at_month = model.ended_at.getMonth() + 1;
        }

        return model;
    }

    async onChange(model) {
        await super.onChange({
            ...model,
            ...this.setDateFromInputs(model, 'started_at'),
            ...this.setDateFromInputs(model, 'ended_at'),
        });

        let errors = {
            ...this.validateDateBeforeToday('started_at', 'Start date'),
            ...this.validateDateAfterDate('ended_at', 'started_at')
        };
        if (errors.ended_at === null) {
            errors = TB.merge(errors, {
                ...this.validateDateBeforeToday('ended_at', 'End date'),
            });
        }

        if (Object.keys(errors).length) {
            this.formRef.current.updateInputsWithError(errors)
        }
    }

    /**
     * The fields mapping for the form
     */
    formFields_LEGACY = () => {

        // 'schools.*.name'            => 'required|string|max:255',
        // 'schools.*.earned_degree'   => 'required|string|max:255',
        // 'schools.*.field_of_study'  => 'required|string|max:255',
        // 'schools.*.started_at'      => 'required|date',
        // 'schools.*.ended_at'        => 'nullable|date',

        let { start_date } = this.state.model;
        let endMinDate = start_date || new Date();

        if (start_date && typeof start_date === 'string') {
            endMinDate = Date.parse(start_date);
        }

        return [
            {
                style: styles.fieldSection,
                fields: {
                    name: {
                        type: 'text',
                        label: TB.trans('talent.school_form.school_name_label'),
                        maxLength: 255,
                        required: true,
                        placeholder: TB.trans('talent.school_form.school_name_placeholder'),
                        style: styles.field,
                        columns: 10
                    }
                }
            },
            {
                style: styles.fieldSection,
                fields: {
                    started_at: {
                        type: 'hidden-date',
                        label: TB.trans('talent.school_form.start_date_label'),
                        required: false,
                        style: styles.field,
                        maxDate: new Date(),
                        className: 'field hide-input',
                        columns: 10
                    }
                }
            },
            {
                style: styles.fieldSection,
                className: 'field-section field-section-select',
                fields: {
                    started_at_month: {
                        label: false,
                        placeholder: 'Month',
                        type: 'select',
                        required: false,
                        options: this.monthOptions(),
                        labelClassName: 'hide-label',
                        className: 'field hide-label',
                        style: { ...styles.field, maxWidth: 110, paddingRight: 0 },
                        hideVisibility: !this.props.isEditing && !this.state.model.started_at_month
                    },
                    started_at_year: {
                        label: false,
                        placeholder: 'Year',
                        type: 'select',
                        required: parseInt(this.state.model.started_at_month) > 0,
                        labelClassName: 'hide-label',
                        options: this.yearOptions(),
                        style: { ...styles.field, maxWidth: 110 },
                        validations: {

                            need_year: ({ model }, value) => {
                                if (model.started_at_month && (value === '' || TB.isNaN(value))) {
                                    return 'Year is required with a month'
                                }

                                return true;
                            }
                        },
                        hideVisibility: !this.props.isEditing && !this.state.model.started_at_year
                    },
                }
            },
            {
                style: styles.fieldSection,
                fields: {
                    ended_at: {
                        type: 'hidden-date',
                        label: TB.trans('talent.school_form.end_date_label'),
                        required: false,
                        style: styles.field,
                        className: 'field hide-input',
                        maxDate: new Date(),
                        minDate: endMinDate,
                        columns: 10,
                        hideVisibility: !this.props.isEditing && !this.state.model.ended_at
                    }
                }
            },
            {
                style: styles.fieldSection,
                className: 'field-section field-section-select',
                fields: {
                    ended_at_month: {
                        label: false,
                        placeholder: 'Month',
                        type: 'select',
                        required: false,
                        options: this.monthOptions(),
                        labelClassName: 'hide-label',
                        className: 'field hide-label',
                        style: { ...styles.field, maxWidth: 110, paddingRight: 0 },
                        hideVisibility: !this.props.isEditing && !this.state.model.ended_at
                    },
                    ended_at_year: {
                        label: false,
                        placeholder: 'Year',
                        type: 'select',
                        required: parseInt(this.state.model.ended_at_month) > 0,
                        labelClassName: 'hide-label',
                        validations: {

                            need_year: ({ model }, value) => {
                                if (model.ended_at_month && (value === '' || TB.isNaN(value))) {
                                    return 'Year is required with a month'
                                }

                                return true;
                            }
                        },
                        options: this.yearOptions(),
                        style: { ...styles.field, maxWidth: 110 },
                        hideVisibility: !this.props.isEditing && !this.state.model.ended_at
                    },
                }
            },
            {
                style: styles.fieldSection,
                fields: {
                    field_of_study: {
                        type: 'text',
                        label: TB.trans('talent.school_form.area_of_study_label'),
                        maxLength: 255,
                        required: true,
                        placeholder: TB.trans('talent.school_form.area_of_study_placeholder'),
                        style: styles.field,
                        columns: 10
                    }
                }
            }, {
                style: styles.fieldSection,
                fields: {
                    earned_degree: {
                        type: 'text',
                        label: TB.trans('talent.school_form.earned_degree_label'),
                        maxLength: 255,
                        required: false,
                        placeholder: TB.trans('talent.school_form.earned_degree_placeholder'),
                        style: styles.field,
                        columns: 10,
                    }
                }
            },
        ]
    };
    renderTitle() {
        return null;
    }

    renderFormFields() {
        const { isEditing } = this.props;

        if (isEditing) {
            return (
                <TalentAppCard.Section>
                    {this.renderFormData()}
                </TalentAppCard.Section>
            )
        }

        return (
            <TalentAppCard.Section>
                {this.renderFormattedData()}
            </TalentAppCard.Section>
        )
    }

    renderFormData = () => {
        const { disabled, isEditing } = this.props;
        const isDisabled = disabled || !isEditing;
        const monthOptions = this.monthOptions();
        const yearOptions = this.yearOptions();

        return (
            <div>
                <FormInputComponent
                    type="antd-input"
                    fieldName="name"
                    label={TB.trans('talent.school_form.school_name_label')}
                    maxLength={255}
                    required
                    value={this.state.model.name}
                >
                    <Input
                        placeholder={TB.trans('talent.school_form.school_name_placeholder')}
                        disabled={isDisabled}
                        className="input-default"
                    />
                </FormInputComponent>

                {/* talent-application .wripple-form .form-container form .field .form-group select */}


                <div className="flex flex-col gap-4 field-section field-section-select">
                    <div>
                        <div className="field hide-input">
                            <FormInputComponent
                                type="hidden-date"
                                fieldName="started_at"
                                label={TB.trans('talent.school_form.start_date_label')}
                                required={false}
                                maxDate={new Date()}
                                value={this.state.model.started_at}
                            />
                        </div>
                        <div className="flex flex-row gap-2 form-group field select-field">
                            <div className="w-full max-w-[130px]">
                                <FormInputComponent
                                    fieldName="started_at_month"
                                    type="select"
                                    label={false}
                                    placeholder="Month"
                                    required={false}
                                    options={monthOptions}
                                    labelClassName="hide-label"
                                    className="field hide-label"
                                    value={this.state.model.started_at_month}
                                />
                            </div>
                            <div className="w-full max-w-[130px]">
                                <FormInputComponent
                                    fieldName="started_at_year"
                                    type="select"
                                    label={false}
                                    placeholder="Year"
                                    required={parseInt(this.state.model.started_at_month) > 0}
                                    options={yearOptions}
                                    labelClassName="hide-label"
                                    value={this.state.model.started_at_year}
                                    validations={{
                                        need_year: ({ model }, value) => {
                                            if (model.started_at_month && (value === '' || TB.isNaN(value))) {
                                                return 'Year is required with a month'
                                            }
                                            return true;
                                        }
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="flex flex-col gap-4 field-section field-section-select">
                    <div>
                        <div className="field hide-input">
                            <FormInputComponent
                                type="hidden-date"
                                fieldName="ended_at"
                                label={TB.trans('talent.school_form.end_date_label')}
                                required={false}
                                maxDate={new Date()}
                                value={this.state.model.ended_at}
                            />
                        </div>
                        <div className="flex flex-row gap-2 form-group field select-field">
                            <div className="w-full max-w-[130px]">
                                <FormInputComponent
                                    fieldName="ended_at_month"
                                    type="select"
                                    label={false}
                                    placeholder="Month"
                                    required={false}
                                    options={monthOptions}
                                    labelClassName="hide-label"
                                    className="field hide-label"
                                    value={this.state.model.ended_at_month}
                                />
                            </div>
                            <div className="w-full max-w-[130px]">
                                <FormInputComponent
                                    fieldName="ended_at_year"
                                    type="select"
                                    label={false}
                                    placeholder="Year"
                                    required={parseInt(this.state.model.ended_at_month) > 0}
                                    options={yearOptions}
                                    labelClassName="hide-label"
                                    value={this.state.model.ended_at_year}
                                    validations={{
                                        need_year: ({ model }, value) => {
                                            if (model.ended_at_month && (value === '' || TB.isNaN(value))) {
                                                return 'Year is required with a month'
                                            }
                                            return true;
                                        }
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="flex flex-col sm:flex-row gap-4 pt-2">
                    <div className="flex-1">
                        <FormInputComponent
                            type="antd-input"
                            fieldName="field_of_study"
                            label={TB.trans('talent.school_form.area_of_study_label')}
                            maxLength={255}
                            required
                            value={this.state.model.field_of_study}
                        >
                            <Input
                                placeholder={TB.trans('talent.school_form.area_of_study_placeholder')}
                                disabled={isDisabled}
                                className="input-default"
                            />
                        </FormInputComponent>
                    </div>
                    <div className="flex-1">
                        <FormInputComponent
                            type="antd-input"
                            fieldName="earned_degree"
                            label={TB.trans('talent.school_form.earned_degree_label')}
                            maxLength={255}
                            required={false}
                            value={this.state.model.earned_degree}
                        >
                            <Input
                                placeholder={TB.trans('talent.school_form.earned_degree_placeholder')}
                                disabled={isDisabled}
                                className="input-default"
                            />
                        </FormInputComponent>
                    </div>
                </div>
            </div>
        )
    }

    renderFormattedData() {
        const { name, field_of_study, earned_degree, started_at, ended_at } = this.state.model;

        const formatDate = (date) => {
            if (!date) return null;
            if (typeof date === 'string') date = new Date(date);
            return dateformat(date, 'mmm yyyy');
        };

        const startDate = formatDate(started_at);
        const endDate = formatDate(ended_at);

        return (
            <div className="flex-1 min-w-0">
                <p className="text-sm font-semibold m-0 truncate">{name || '—'}</p>
                <div className="flex flex-col sm:flex-row sm:items-center gap-x-4 gap-y-0.5 mt-1">
                    {field_of_study && (
                        <p className="text-sm text-gray-600 m-0 truncate">{field_of_study}</p>
                    )}
                    {earned_degree && (
                        <p className="text-sm text-gray-500 m-0 truncate">{earned_degree}</p>
                    )}
                </div>
                {(startDate || endDate) && (
                    <p className="text-xs text-gray-500 mt-1 m-0">
                        {startDate}{startDate && endDate ? ' — ' : ''}{endDate}
                    </p>
                )}
            </div>
        )
    }

    renderFormFooterInfo() {
        return <div />
    }

    renderEditFormButton() {
        return (
            <button
                className="btn btn-primary px-6"
                disabled={this.props.disabled}
                type="button" onClick={() => this.props.onEditing(true)}
            >
                Edit School
            </button>
        );
    }

    renderProfilePreview() {
        return (
            <TalentAppCard.Section>
                <ProfileSchoolRow school={this.getModelFromProps()} />
            </TalentAppCard.Section>
        )
    }
}

const styles = {
    fieldSection: {
        flexDirection: 'row'
    },
    field: {
        padding: '0 15px',
    },
};